export const Scan = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" fill="white" fill-opacity="0.01" style="mix-blend-mode:multiply"/>
<path d="M29 10V3H22" stroke="currentColor" stroke-width="2"/>
<path d="M10 3H3V10" stroke="currentColor" stroke-width="2"/>
<path d="M3 22V29H10" stroke="currentColor" stroke-width="2"/>
<path d="M22 29H29V22" stroke="currentColor" stroke-width="2"/>
<path d="M2 16H30" stroke="currentColor" stroke-width="2"/>
<path d="M23 13V10C23 9.44772 22.5523 9 22 9H10C9.44772 9 9 9.44772 9 10V13" stroke="currentColor" stroke-width="2"/>
<path d="M9 19V22C9 22.5523 9.44772 23 10 23H22C22.5523 23 23 22.5523 23 22V19" stroke="currentColor" stroke-width="2"/>
<path d="M2 16H30" stroke="currentColor" stroke-width="2"/>
</svg>`;
